// Opens a printable invoice in a new window (save as PDF via browser print).
export function downloadInvoice(inv, opts = {}) {
  const brand = "JobBasket.Network";
  const dateStr = inv.date ? new Date(inv.date).toLocaleString("en-GB", { dateStyle: "medium", timeStyle: "short" }) : "—";
  const rows = [
    ["Invoice Number", inv.invoice_no],
    ["Date", dateStr],
    ["Plan", inv.plan],
    ["Payment Method", inv.method],
    inv.email ? ["Billed To", inv.email] : null,
    ["Payment ID", inv.payment_id || inv.order_id || "—"],
    ["Status", (inv.status || "").toUpperCase()],
  ].filter(Boolean);

  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${inv.invoice_no}</title>
  <style>
    *{font-family:-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;box-sizing:border-box}
    body{margin:0;padding:48px;color:#0f172a}
    .bar{height:6px;background:#f59e0b;border-radius:4px;margin-bottom:28px}
    h1{font-size:26px;margin:0}
    .muted{color:#64748b}
    .head{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:36px}
    .badge{display:inline-block;padding:4px 12px;border-radius:999px;background:#ecfdf5;color:#059669;font-weight:700;font-size:12px;text-transform:uppercase}
    table{width:100%;border-collapse:collapse;margin-top:8px}
    td{padding:12px 0;border-bottom:1px solid #f1f5f9;font-size:14px}
    td.k{color:#64748b;width:40%}
    td.v{font-weight:600;text-align:right}
    .total{margin-top:32px;background:#fffbeb;border:1px solid #fde68a;border-radius:16px;padding:20px 24px;display:flex;justify-content:space-between;align-items:center}
    .total .amt{font-size:30px;font-weight:800}
    .foot{margin-top:40px;font-size:12px;color:#94a3b8}
  </style></head><body>
    <div class="bar"></div>
    <div class="head">
      <div><h1>${brand}</h1><div class="muted">Recruitment Outreach Platform</div></div>
      <div style="text-align:right"><div style="font-weight:700;font-size:18px">INVOICE</div><div class="muted">${inv.invoice_no}</div><div style="margin-top:8px"><span class="badge">${(inv.status||"").toUpperCase()}</span></div></div>
    </div>
    <table>${rows.map(([k, v]) => `<tr><td class="k">${k}</td><td class="v">${v}</td></tr>`).join("")}</table>
    <div class="total"><div><div class="muted" style="font-size:13px">Amount Paid</div><div style="font-weight:700">${inv.plan}</div></div><div class="amt">₹${Number(inv.amount).toLocaleString("en-IN")}</div></div>
    <div class="foot">This is a system-generated invoice for ${brand}. ${opts.note || ""}</div>
    <script>window.onload=()=>{setTimeout(()=>window.print(),300)}</script>
  </body></html>`;

  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(html);
  w.document.close();
}

export function monthLabel(m) {
  if (!m) return "";
  const [y, mo] = m.split("-");
  return new Date(Number(y), Number(mo) - 1, 1).toLocaleString("en-GB", { month: "long", year: "numeric" });
}
